import { BlogArticleQuery } from '@/graphql';
import dayjs from 'dayjs';

/**
 * These  schemas follow next js docs https://nextjs.org/docs/app/guides/json-ld
 */

export const HomepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  'name': 'Front',
  'url': 'https://front.com/',
  'logo': 'https://front.com/favicon-96x96.png',
  'sameAs': [
    'https://www.facebook.com/FrontHQ',
    'https://www.instagram.com/FrontHQ',
    'https://www.linkedin.com/company/fronthq',
  ],
  'aggregateRating': {
    '@type': 'AggregateRating',
    'ratingValue': '4.7',
    'ratingCount': '2372',
  },
} as const;

export const createBlogArticleSchema = (entry: BlogArticleQuery['entry']) => {
  const coverImage = entry?.coverImage?.[0];
  const author = entry?.contentAuthor?.[0];

  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    'mainEntityOfPage': {
      '@type': 'WebPage',
      '@id': entry?.url || '',
    },
    'headline': entry?.title || '',
    'description': entry?.summary || '',
    'image': coverImage?.url || '',
    'author': {
      '@type': 'Person',
      'name': author?.authorName || '',
    },
    'publisher': {
      '@type': 'Organization',
      'name': 'Front',
      'logo': {
        '@type': 'ImageObject',
        'url': 'https://front.com/favicon-96x96.png',
      },
    },
    'datePublished': entry?.postDate ? dayjs(entry.postDate).format('YYYY-MM-DD') : '',
  } as const;
};
